import { useId } from 'react'

import { useTranslation } from 'react-i18next'

import { HStack, Input, Text } from '@enechain/ecloud-designsystem'
import { FaLockRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  /** 欄のラベル (スクリーンリーダー用)。 */
  label: string
  /** 保存済みの値の表示。 */
  value: string
}

/**
 * 自動起票ルールの編集で変えられない項目 (雛形・エリア・起票リード) の表示。
 * disabled 相当の見た目に「変更不可」の補足を添える (design/CLAUDE.md の
 * `.form-lock-hint` 規約。AC-WFT-021)。
 */
export const AutoCreationRuleImmutableValue = ({
  label,
  value,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const hintId = useId()
  return (
    <>
      <Input
        color="Text.disabled"
        background="Surface.tertiary"
        cursor="not-allowed"
        aria-describedby={hintId}
        aria-label={label}
        readOnly
        value={value}
      />
      <HStack
        alignItems="center"
        gap={1}
        marginTop={1}
        color="Text.midEmphasis"
        id={hintId}
      >
        <FaLockRegular boxSize={iconSize.fieldMessage} />
        <Text as="span" fontSize="sm">
          {t('common:form.immutableHint')}
        </Text>
      </HStack>
    </>
  )
}
